import { Action } from './Action.js';
/**
 * @class StartApplication
 * @extends Action
 * @classdesc Действие Открыть
 * */
export class StartApplication extends Action {	
	execute() {
		if (window.ipc) {
            const obj = {
                path: this.Path, 
                args: this.Arguments,
                options: {
                    windowsHide: this.WindowsHide !== undefined ? this.WindowsHide : false, 
                    shell: this.Shell !== undefined ? this.Shell : false,
                }
            }
            if(this.Cwd){   
                obj.options.cwd = this.Cwd
            }
            window.ipc.get().send("server", "startApplication", obj);
        }
	}    

    get Path(){
        return this._path
    }

    set Path(value){
        this._path = value
    }

    get Arguments(){
        return this._arguments
    }

    set Arguments(value){
        this._arguments = value.length ? this.parseString(value) : []
    }

    get Cwd(){
        return this._cwd
    }

    set Cwd(value){
        this._cwd = value
    }

    get WindowsHide(){
        return this._windowshide
    }

    set WindowsHide(value){
        this._windowshide = value
    }

    get Shell(){
        return this._shell
    }

    set Shell(value){
        this._shell = value
    }

    parseString(string) {
        const matches = string.match(/"([^"]+)"|\S+/g) || [];
        return matches.map(match => match.replace(/"/g, ''));
    }
}